import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-2 gap-4 lg:gap-6" }
const _hoisted_2 = { class: "grid grid-cols-2 text-sm font-basier lg:text-base" }
const _hoisted_3 = { class: "block" }
const _hoisted_4 = { class: "ml-1" }
const _hoisted_5 = { class: "block" }
const _hoisted_6 = { class: "block" }
const _hoisted_7 = { class: "block" }
const _hoisted_8 = { class: "block" }
const _hoisted_9 = { class: "text-sm font-basier lg:text-base" }
const _hoisted_10 = { class: "block" }
const _hoisted_11 = { class: "ml-1" }
const _hoisted_12 = { class: "block" }
const _hoisted_13 = { class: "flex flex-col text-sm font-basier text-dark-gray lg:text-base lg:flex-row lg:space-x-24" }
const _hoisted_14 = { class: "w-full lg:space-y-1" }
const _hoisted_15 = { class: "grid grid-cols-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold lg:font-normal" }, "Tonaż wyładunkowy:", -1)
const _hoisted_17 = { class: "inline-block lg:text-right" }
const _hoisted_18 = { class: "grid grid-cols-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold lg:font-normal" }, "Nr pojazdu / nr naczepy:", -1)
const _hoisted_20 = { class: "inline-block lg:text-right" }
const _hoisted_21 = { class: "grid grid-cols-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold lg:font-normal" }, "Załadunek:", -1)
const _hoisted_23 = { class: "inline-block lg:text-right" }
const _hoisted_24 = { class: "lg:font-bold" }
const _hoisted_25 = { class: "block lg:inline" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "hidden lg:inline" }, "godz.", -1)
const _hoisted_27 = { class: "grid grid-cols-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold lg:font-normal" }, "Dostawa:", -1)
const _hoisted_29 = { class: "inline-block lg:text-right" }
const _hoisted_30 = { class: "lg:font-bold" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "block lg:inline" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "hidden lg:inline" }, "godz."),
  /*#__PURE__*/_createTextVNode(" 00:00 - 00:00 ")
], -1)
const _hoisted_32 = { class: "grid grid-cols-2" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold lg:font-normal" }, "Grafik:", -1)
const _hoisted_34 = { class: "inline-block lg:text-right" }
const _hoisted_35 = { class: "w-full lg:space-y-1" }
const _hoisted_36 = { class: "grid grid-cols-2" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold lg:font-normal" }, "Imię i nazwisko kierowcy:", -1)
const _hoisted_38 = { class: "inline-block lg:text-right" }
const _hoisted_39 = { class: "grid grid-cols-2" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold lg:font-normal" }, "Dokument tożsamości:", -1)
const _hoisted_41 = { class: "inline-block lg:text-right" }
const _hoisted_42 = { class: "grid grid-cols-2" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold lg:font-normal" }, "Nr dokumentu:", -1)
const _hoisted_44 = { class: "inline-block lg:text-right" }
const _hoisted_45 = { class: "grid grid-cols-2" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold lg:font-normal" }, "Tel. kierowcy:", -1)
const _hoisted_47 = { class: "inline-block lg:text-right" }
const _hoisted_48 = { class: "grid grid-cols-2" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold lg:font-normal" }, "PIN:", -1)
const _hoisted_50 = { class: "inline-block lg:text-right" }

import { UiCard, UiCardText } from '@/components/common/ui'
import { AdviceDetails } from '@/composables/useAdvices'

type Props = {
    adviceDetails: AdviceDetails
}

export default /*#__PURE__*/_defineComponent({
  props: {
    adviceDetails: { type: null, required: true }
  },
  setup(__props: any) {

const props = __props as {
    adviceDetails: AdviceDetails
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(UiCard), {
      class: "col-span-2 lg:col-span-1",
      title: "Odbiorca"
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(UiCardText), { title: "Dane adresowe" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, _toDisplayString(props.adviceDetails.salesContract.recipient.name), 1),
              _createElementVNode("span", null, _toDisplayString(props.adviceDetails.recipientAdviceAddress?.postcode), 1),
              _createElementVNode("span", _hoisted_4, _toDisplayString(props.adviceDetails.recipientAdviceAddress?.city), 1),
              _createElementVNode("span", _hoisted_5, _toDisplayString(props.adviceDetails.recipientAdviceAddress?.address), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(UiCardText), { title: "Osoba kontaktowa" }, {
            default: _withCtx(() => [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.adviceDetails
                                    .adviceRecipientsEmails, (recipientContact, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `recipientContact-${index}`,
                    class: "mb-3"
                  }, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(recipientContact.adviceEmail.name), 1),
                    _createElementVNode("span", _hoisted_7, " tel. " + _toDisplayString(recipientContact.adviceEmail.phone || '---'), 1),
                    _createElementVNode("span", _hoisted_8, " email: " + _toDisplayString(recipientContact.adviceEmail.phone || '---'), 1)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(UiCardText), {
            class: "col-span-2",
            title: "Notatka"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(props.adviceDetails.recipientAdviceAddress?.note || '---'), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(UiCard), {
      class: "col-span-2 lg:col-span-1",
      title: "Dostawca"
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_unref(UiCardText), { title: "Dane adresowe" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_10, _toDisplayString(props.adviceDetails.purchaseContract.supplier.name), 1),
              _createElementVNode("span", null, _toDisplayString(props.adviceDetails.supplierAdviceAddress?.postcode), 1),
              _createElementVNode("span", _hoisted_11, _toDisplayString(props.adviceDetails.supplierAdviceAddress?.city), 1),
              _createElementVNode("span", _hoisted_12, _toDisplayString(props.adviceDetails.supplierAdviceAddress?.address), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(UiCard), {
      class: "col-span-2",
      title: "Szczegóły awizacji"
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("span", _hoisted_17, _toDisplayString(props.adviceDetails.quantity) + " t ", 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("span", _hoisted_20, _toDisplayString(props.adviceDetails.vehicleIdentificationNumber) + " t ", 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("span", _hoisted_23, [
                _createElementVNode("span", _hoisted_24, _toDisplayString(props.adviceDetails.loadingDate || '0000-00-00') + ", ", 1),
                _createElementVNode("span", _hoisted_25, [
                  _hoisted_26,
                  _createTextVNode(" " + _toDisplayString(props.adviceDetails.loadingTimeFrom || '00:00') + " - " + _toDisplayString(props.adviceDetails.loadingTimeTo || '00:00'), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("span", _hoisted_29, [
                _createElementVNode("span", _hoisted_30, _toDisplayString(props.adviceDetails.deliveryDate || '0000-00-00') + ", ", 1),
                _hoisted_31
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("span", _hoisted_34, _toDisplayString(props.adviceDetails.schedule?.date || '---') + " " + _toDisplayString(props.adviceDetails.schedule?.quantity || '---') + " T ", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("span", _hoisted_38, _toDisplayString(props.adviceDetails.driverFirstName) + " " + _toDisplayString(props.adviceDetails.driverLastName), 1)
            ]),
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createElementVNode("span", _hoisted_41, _toDisplayString(props.adviceDetails.identyficationType?.name || '---'), 1)
            ]),
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("span", _hoisted_44, _toDisplayString(props.adviceDetails.identyficationNumber || '---'), 1)
            ]),
            _createElementVNode("div", _hoisted_45, [
              _hoisted_46,
              _createElementVNode("span", _hoisted_47, _toDisplayString(props.adviceDetails.driverPhone || '---'), 1)
            ]),
            _createElementVNode("div", _hoisted_48, [
              _hoisted_49,
              _createElementVNode("span", _hoisted_50, _toDisplayString(props.adviceDetails.pin || '---'), 1)
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})